
<div>
  <nb-card>
    <nb-card-body [nbSpinner]="isLoading">
      <label *ngIf="!isLoading && Goals?.length === 0">No goal found</label>
      <div *ngFor="let g of Goals; let row=index;">
        <div class="goal-row">

          <nb-card class="{{g.status==0 ? 'active':'inactive'}} goals_items">
            <nb-card-header>
              <div class="subtitle">
                {{getGoalName(g)}}
              </div>

              <div class="actions" *ngIf="!IsView">

                <!--<a href="javascript:void(0);" class="action" *ngIf="g.status==0">
                  <nb-icon icon="checkmark">
                  </nb-icon>
                </a>

                <a class="action" *ngIf="g.status!=0">
                  <nb-icon icon="close-square-outline" class="inactive">
                  </nb-icon>
                </a>-->

                <a href="javascript:void(0);" class="action" i18n-title="@@Edit" title="Edit" (click)="onEdit(row)">
                  <nb-icon icon="modify-pencil-outline" pack="custom"></nb-icon>
                </a>

                <a href="javascript:void(0);" class="action" i18n-title="@@Delete" title="Delete" (click)="onDelete(row)">
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </a>

              </div>
            </nb-card-header>

            <nb-card-body>
              <div class="row">
                <div class="col-md-5 col-sm-12">

                  <div>
                    <ul class="basic_list_informations">
                      <li style="width:150px" class="DimmedLabel"><ng-container i18n="@@CreatedOn">Created on</ng-container>:</li>
                      <li><b>{{ g.createdDate }}</b></li>
                    </ul>
                    <ul class="basic_list_informations">
                      <li class="DimmedLabel"><ng-container i18n="@@UpdatedOn">Updated on</ng-container>:</li>
                      <li><b>{{ g.updatedDate  }}</b></li>
                    </ul>
                    <ul class="basic_list_informations">
                      <li class="DimmedLabel"><ng-container i18n="@@EndDate">End date</ng-container>:</li>
                      <li><b>{{ g.targetDate  }}</b></li>
                    </ul>
                    <ul class="basic_list_informations">
                      <li class="DimmedLabel"><ng-container i18n="@@GoalType">Goal Type</ng-container>:</li>
                      <li><b>{{ g.goalTypeDetail  }}</b></li>
                    </ul>
                    <ul class="basic_list_informations">
                      <li class="DimmedLabel"><ng-container i18n="@@Start">Start</ng-container> {{g.goalType}}: </li>
                      <li><b>{{ g.startValue }} {{g.goalType == 'Weight' ? (Patient && Patient.isPreferredUnitImperial ? 'lbs':'kg'):''}}</b></li>
                    </ul>
                    <ul class="basic_list_informations">
                      <li class="DimmedLabel"><ng-container i18n="@@Target">Target</ng-container> {{g.goalType}}:</li>
                      <li><b>{{ g.goalValue }} {{g.goalType == 'Weight' ? (Patient && Patient.isPreferredUnitImperial ? 'lbs':'kg'):''}}</b></li>
                    </ul>
                  </div>

                  <div class="item-row">
                    <nb-progress-bar [value]="g.progress> 0 ? g.progress: 0"  [displayValue]="true" class="{{g.progress > 0 ? '': 'zero-progress' }}"></nb-progress-bar>
                  </div>
                </div>

                <div class="col-md-7 col-sm-12">
                  <div class="line-graph">
                    <chart #chart type="line" [data]="GraphData[row]" [options]="options"></chart>
                  </div>
                </div>
              </div>

            </nb-card-body>

          </nb-card>

        </div>



      </div>

    </nb-card-body>

    <nb-card-footer *ngIf="!IsView">
      <table class="float-left" *ngIf="AllowEdit">
        <tr>
          <td>
            <button i18n="@@AddNewGoal" nbButton type="submit" class="btn-circle btn-xl btn-main" (click)="AddGoal()" >Add New Goal</button>
          </td>
        </tr>
      </table>
    </nb-card-footer>
  </nb-card>

</div>
